import type from './types';
import { getListTransform } from 'helpers/transformResponse';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  loading: true,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.LIST_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload) || INITIAL_STATE.list,
        loading: false,
      };
    case type.LIST_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
